import React from 'react';
import PropTypes from 'prop-types';

const SingleBoldArrowIcon = ({ width, height }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.4393 7.56066C14.8536 6.97487 14.8536 6.02513 15.4393 5.43934C16.0251 4.85355 16.9749 4.85355 17.5607 5.43934L23.0607 10.9393C23.6464 11.5251 23.6464 12.4749 23.0607 13.0607L17.5607 18.5607C16.9749 19.1464 16.0251 19.1464 15.4393 18.5607C14.8536 17.9749 14.8536 17.0251 15.4393 16.4393L18.3787 13.5H2C1.17157 13.5 0.5 12.8284 0.5 12C0.5 11.1716 1.17157 10.5 2 10.5H18.3787L15.4393 7.56066Z"
        fill="#323232"
      />
    </svg>
);

SingleBoldArrowIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default SingleBoldArrowIcon;
